module.exports = __webpack_public_path__ + "static/img/2-2.dfc1e41.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/2-2.png
// module id = 264
// module chunks = 0